import { createSelector } from 'reselect'

export const root = state => state.get('enrichment').demandbase
export const demandbaseCompanyDataByIp = (ip) => createSelector(root, (root) => root.getIn(['data', 'byIp', ip]))
export const demandbaseCompanyDataByEndUser = (endUserId) => createSelector(root, root => root.getIn(['data', 'byEndUserId', endUserId]))
export const demandbaseTargetingIndustries = state => root(state).get('industries')
export const demandbaseTargetingSubIndustries = state => root(state).get('subIndustries')


// WEBPACK FOOTER //
// ./src/scripts/app/modules/enrichment/demandbase/selectors.js